"use client";

import React, { useEffect, useState } from "react";
import { Dropdown, Button } from "antd";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./AlfaHeaderCountryDropdown.scss";
import fashionApi from "@/Apis/FashionApi";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";

const COUNTRIES = [
  { id: 23, name: "Pakistan", code: "PK", currency: "PKR" },
  { id: 1, name: "United States", code: "US", currency: "USD" },
  { id: 2, name: "United Kingdom", code: "GB", currency: "GBP" },
  { id: 3, name: "Canada", code: "CA", currency: "CAD" },
  { id: 4, name: "Australia", code: "AU", currency: "AUD" },
];

const AlfaHeaderCountryDropdown = ({
  // selectedCountry = "Pakistan",
  onCountryChange = () => {},
}) => {
  const router = useRouter();
  const [countries, setCountries] = useState(COUNTRIES);
  const [isOpen, setIsOpen] = useState(false);

  const selectedCountry = Cookies.get("fashionCurrencyName") || "PKR";
  const selectedCountryName = Cookies.get("fashionCountry") || "Pakistan";

  const handleCountrySelect = (country) => {
    onCountryChange(country);
    setIsOpen(false);

    if (!country?.id || !country.currency) return;
    const prevStorefrontId = Cookies.get("defaultCurrencyId");
    const nextStorefrontId = String(country.id);

    // // If storefront changes, existing carts are in the old currency.
    // // Clearing forces the app to recreate carts with the new storefront.
    // if (prevStorefrontId && String(prevStorefrontId) !== nextStorefrontId) {
    //   Cookies.remove("fashion_cart_id");
    //   Cookies.remove("cartId");
    // }

    Cookies.set("fashionCurrencyName", country.currency);
    Cookies.set("fashionCurrencyId", nextStorefrontId);
    Cookies.set("fashionCountry", country.name);
    window.location.reload();
  };

  const menuItems = countries.map((country) => ({
    key: country.id,
    label: (
      <div className="fashion-header-country-dropdown__item">
        <span className="fashion-header-country-dropdown__item-name">
          {country.name}
        </span>
        <span className="fashion-header-country-dropdown__item-code">
          {country.code}
        </span>
      </div>
    ),
    onClick: () => handleCountrySelect(country),
  }));

  const handleGetStoreList = async () => {
    try {
      const result = await fashionApi.getStoreList();
      const availableStores = result?.data?.country_list;

      if (availableStores && availableStores.length > 0) {
        const options = availableStores.map((store) => ({
          id: store.id,
          name: store.country,
          code: store.short_code,
          currency: store.currency,
        }));

        setCountries(options);
      }
    } catch (error) {
      console.error("Failed fetching stores");
    }
  };

  useEffect(() => {
    handleGetStoreList();
  }, []);

  return (
    <div className="fashion-header-country-dropdown">
      <Dropdown
        menu={{ items: menuItems }}
        trigger={["click"]}
        open={isOpen}
        onOpenChange={setIsOpen}
        placement="bottomLeft"
      >
        <Button className="fashion-header-country-dropdown__button" type="text">
          <span className="fashion-header-country-dropdown__text">
            {selectedCountry}
          </span>
          <MdKeyboardArrowDown
            fill="none"
            className={`fashion-header-country-dropdown__icon ${
              isOpen ? "fashion-header-country-dropdown__icon--open" : ""
            }`}
          />
        </Button>
      </Dropdown>
    </div>
  );
};

export default AlfaHeaderCountryDropdown;
